import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(
    private http: HttpClient,
  ) { }

  logIn(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/api/v1/auth/login', JSON.stringify(item), {withCredentials: true});
  }

  adminRegister(item: any): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/api/v1/auth/admin-register', JSON.stringify(item), {withCredentials: true});
  }

  logout(): Observable<any> {
    return this.http
      .post<any>(environment.apiUrl + '/api/v1/user/logout', {withCredentials: true});
  }
}
